<template>
  <div>
    <div class="relationalDatabaseServiceResourceAzure-title">
      <div>{{ $t("RAM.Azure.database.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:relationalDatabaseServiceResourceAzure:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:relationalDatabaseServiceResourceAzure:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="relationalDatabaseServiceResourceAzure-top">
      <relational-database-service-resource-azure-search
        ref="relationalDatabaseServiceResourceAzureSearchChild"
      ></relational-database-service-resource-azure-search>
    </div>
    <table-relational-database-service-resource-azure></table-relational-database-service-resource-azure>
  </div>
</template>

<script>
import RelationalDatabaseServiceResourceAzureSearch from "../rds/RelationalDatabaseServiceResourceAzureSearch";
import TableRelationalDatabaseServiceResourceAzure from "../rds/TableRelationalDatabaseServiceResourceAzure";

export default {
  name: "RelationalDatabaseServiceResourceAzure",
  components: {
    RelationalDatabaseServiceResourceAzureSearch,
    TableRelationalDatabaseServiceResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.relationalDatabaseServiceResourceAzureSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 202
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.relationalDatabaseServiceResourceAzureSearchChild.accountNameSearchKey;
      this.companyId = this.$refs.relationalDatabaseServiceResourceAzureSearchChild.companyId;

      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureDatabase({
          accountName: this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "数据库.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.relationalDatabaseServiceResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.relationalDatabaseServiceResourceAzure-title > div:nth-child(1) {
  float: left;
}
.relationalDatabaseServiceResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.relationalDatabaseServiceResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/rds/RelationalDatabaseServiceResourceAzure.vue